export default __webpack_public_path__ + "static/media/kinder.cd4af6f6.mp4";